"use strict";

const BaseModuleSettings = require("./baseModuleSettings");

const ConstructionModuleSettings = function () {
  const tool = "construction";
  const key = "construction-module";
  const formKey = "construction-module-settings";
  const option = "Construction Module";
  const iconClass = "construction";
  const userVariableValidatorClassConstruction =
    "validate-construction-maintenance-notice-variables";
  const moduleProps = { userVariableValidatorClassConstruction };

  const initValidatorFunction = (props) => {
    UserVariableValidator.init(
      Object.keys(props?.construction?.maintenanceNoticeUserTemplate || {}),
      `.${userVariableValidatorClassConstruction}`,
    );
  };

  const base = new BaseModuleSettings(
    tool,
    key,
    formKey,
    option,
    iconClass,
    moduleProps,
    initValidatorFunction,
  );

  return {
    ...base,
  };
};

module.exports = ConstructionModuleSettings();

const UserVariableValidator = require("../../misc/userVariableValidator");
